import { render, staticRenderFns } from "./AcceptCopy.vue?vue&type=template&id=9bd5f782&"
import script from "./AcceptCopy.vue?vue&type=script&lang=js&"
export * from "./AcceptCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports